import { render, staticRenderFns } from "./carTrend.vue?vue&type=template&id=24705aab&scoped=true&"
import script from "./carTrend.vue?vue&type=script&lang=js&"
export * from "./carTrend.vue?vue&type=script&lang=js&"
import style0 from "./carTrend.vue?vue&type=style&index=0&id=24705aab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24705aab",
  null
  
)

export default component.exports